import React, { useState, useEffect } from "react";
import { Star } from "lucide-react";
import { reviewsAPI } from "../../api";
import "./Reviews.css";

const ReviewsList = ({ userId, showTitle = true }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadReviews = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await reviewsAPI.getUserReviews(userId);
        setReviews(response.data);
      } catch (err) {
        setError("Erreur lors du chargement des avis");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      loadReviews();
    }
  }, [userId]);

  const calculateAverageRating = () => {
    if (reviews.length === 0) return 0;
    const sum = reviews.reduce((acc, review) => acc + review.rating, 0);
    return (sum / reviews.length).toFixed(1);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const renderStars = (rating) => {
    return (
      <div className="review-stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            size={16}
            strokeWidth={1.75}
            color="var(--warning)"
            fill={star <= rating ? "var(--warning)" : "none"}
          />
        ))}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="reviews-container">
        {showTitle && <h3>Avis</h3>}
        <div className="loading">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="reviews-container">
        {showTitle && <h3>Avis</h3>}
        <div className="alert alert-error">{error}</div>
      </div>
    );
  }

  const averageRating = calculateAverageRating();

  return (
    <div className="reviews-container">
      {showTitle && (
        <div className="reviews-header">
          <h3>Avis</h3>
          {reviews.length > 0 && (
            <div className="reviews-summary">
              <div className="average-rating">
                <span className="average-rating-value">{averageRating}</span>
                <div className="average-rating-stars">
                  {renderStars(Math.round(parseFloat(averageRating)))}
                </div>
                <span className="reviews-count">({reviews.length} avis)</span>
              </div>
            </div>
          )}
        </div>
      )}

      {reviews.length === 0 ? (
        <div className="empty-reviews">
          <p>Aucun avis pour le moment</p>
        </div>
      ) : (
        <div className="reviews-list">
          {reviews.map((review) => (
            <div key={review.id} className="review-item">
              <div className="review-header">
                <div className="review-reviewer">
                  <strong>{review.reviewer.name}</strong>
                  <span className="review-date">{formatDate(review.created_at)}</span>
                </div>
                <div className="review-rating">{renderStars(review.rating)}</div>
              </div>
              {review.comment && (
                <div className="review-comment">
                  <p>{review.comment}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReviewsList;

